import $ from "jquery";
import plugin from "@core/plugins/lib";
import { onAvailable } from '@core/plugins/lib/selectors';

const ELEMENT_SELECTOR = '[data-ajax-submit]';
const PLUGIN_NAME = 'ajaxSubmit';

$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function(element) {
		System.import(/* webpackChunkName: "ajax-submit" */ './ajax-submit').then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/ajax-submit/plugin--available.js